import { PathOptions } from "leaflet";

export const subestacoes_expansao_planejada = (feature: any): PathOptions => {
  // White circle with black border (planned substations)
  return {
    color: "#000000", // Black border
    weight: 1,
    opacity: 1,
    fillColor: "#ffffff", // White fill
    fillOpacity: 1,
  };
};
